@if (thing ) {
  @if (((thing.__typename == 'Folder' || thing.__typename == 'Parent'))) {
    <i class="fas fa-folder"></i>
  } @else {
    @if (!thing.deleted) {
      @switch (thing.name.toLowerCase().split('.').pop()) {
        @case ('mov') {
          <i class="fas fa-fw fa-file-video"></i>
        }
        @case ('mp4') {
          <i class="fas fa-fw fa-file-video"></i>
        }
        @case ('mpg') {
          <i class="fas fa-fw fa-file-video"></i>
        }
        @case ('ismv') {
          <i class="fas fa-fw fa-file-video"></i>
        }
        @case ('aif') {
          <i class="fas fa-fw fa-file-audio"></i>
        }
        @case ('wav') {
          <i class="fas fa-fw fa-file-audio"></i>
        }
        @case ('isma') {
          <i class="fas fa-fw fa-file-audio"></i>
        }
        @case ('srt') {
          <i class="fas fa-fw fa-file-alt"></i>
        }
        @case ('dfxp') {
          <i class="fas fa-fw fa-file-alt"></i>
        }
        @case ('ismt') {
          <i class="fas fa-fw fa-file-alt"></i>
        }
        @case ('vtt') {
          <i class="fas fa-fw fa-file-alt"></i>
        }
        @case ('png') {
          <i class="fas fa-fw fa-file-image"></i>
        }
        @case ('jpg') {
          <i class="fas fa-fw fa-file-image"></i>
        }
        @case ('jpeg') {
          <i class="fas fa-fw fa-file-image"></i>
        }
        @case ('zip') {
          <i class="fas fa-fw fa-file-archive"></i>
        }
        @default {
          <i class="fas fa-fw fa-file"></i>
        }
      }
    } @else {
      <i class="fas fa-fw fa-trash" appTooltip="scheduled for permanent deletion"></i>
    }
  }
}
